// Mock data for Gigs / Halturas — frontend preview only (no backend yet).
// Once the model is approved, this is replaced by real API calls.

export const GIG_CATEGORIES = {
  moving: { lv: 'Pārcelšanās un krava', en: 'Moving & Hauling', ru: 'Переезд и грузы', icon: 'Truck' },
  cleaning: { lv: 'Uzkopšana', en: 'Cleaning', ru: 'Уборка', icon: 'Sparkles' },
  handyman: { lv: 'Sīkie remontdarbi', en: 'Handyman', ru: 'Мелкий ремонт', icon: 'Wrench' },
  gardening: { lv: 'Dārza darbi', en: 'Gardening', ru: 'Садовые работы', icon: 'Sprout' },
  delivery: { lv: 'Piegāde / kurjers', en: 'Delivery / Courier', ru: 'Доставка / курьер', icon: 'Package' },
  petcare: { lv: 'Mājdzīvnieki', en: 'Pet Care', ru: 'Уход за животными', icon: 'PawPrint' },
  childcare: { lv: 'Bērnu pieskatīšana', en: 'Childcare', ru: 'Присмотр за детьми', icon: 'Baby' },
  tech_help: { lv: 'Tehniskā palīdzība', en: 'Tech Help', ru: 'Тех. помощь', icon: 'Laptop' },
  events_help: { lv: 'Pasākumu palīgi', en: 'Event Help', ru: 'Помощь на мероприятиях', icon: 'PartyPopper' },
  other: { lv: 'Cits', en: 'Other', ru: 'Другое', icon: 'MoreHorizontal' },
};

export const GIG_STATUS = {
  open: { lv: 'Pieejams', en: 'Open', ru: 'Открыт', color: 'bg-[#4A6B53]' },
  accepted: { lv: 'Pieņemts', en: 'Accepted', ru: 'Принят', color: 'bg-[#D97736]' },
  in_progress: { lv: 'Procesā', en: 'In progress', ru: 'В процессе', color: 'bg-[#6366f1]' },
  completed: { lv: 'Pabeigts', en: 'Completed', ru: 'Завершён', color: 'bg-[#5C5C5C]' },
  cancelled: { lv: 'Atcelts', en: 'Cancelled', ru: 'Отменён', color: 'bg-red-500' },
};

export const GIG_REGIONS = [
  { id: 'riga', name: 'Rīga' },
  { id: 'jurmala', name: 'Jūrmala' },
  { id: 'liepaja', name: 'Liepāja' },
  { id: 'ventspils', name: 'Ventspils' },
  { id: 'daugavpils', name: 'Daugavpils' },
  { id: 'jelgava', name: 'Jelgava' },
  { id: 'valmiera', name: 'Valmiera' },
  { id: 'cesis', name: 'Cēsis' },
  { id: 'sigulda', name: 'Sigulda' },
  { id: 'ogre', name: 'Ogre' },
  { id: 'tukums', name: 'Tukums' },
];

export const MOCK_GIGS = [
  {
    id: 'g-001',
    title: 'Vajadzīga palīdzība mēbeļu pārvietošanā',
    description: 'Jāpārvieto dīvāns, skapis un 8 kastes no 3. stāva uz furgonu. Nepieciešami 2 spēcīgi cilvēki uz ~2 stundām. Lifta nav.',
    category: 'moving',
    budget: 40,
    region: 'riga',
    city: 'Rīga, Āgenskalns',
    distance_km: 2.4,
    radius_km: 10,
    schedule: 'asap',
    scheduled_at: null,
    status: 'open',
    poster_name: 'Jānis B.',
    poster_rating: 4.8,
    poster_reviews: 12,
    created_at: '2026-06-18T09:30:00Z',
  },
  {
    id: 'g-002',
    title: 'Suņa pastaiga rīt no rīta plkst. 8:00',
    description: 'Meklēju uzticamu cilvēku, kas izved manu labradoru 1h pastaigā. Suns draudzīgs, pieradis pie pavadas.',
    category: 'petcare',
    budget: 15,
    region: 'riga',
    city: 'Rīga, Centrs',
    distance_km: 5.1,
    radius_km: 8,
    schedule: 'scheduled',
    scheduled_at: '2026-06-19T08:00:00Z',
    status: 'open',
    poster_name: 'Anna K.',
    poster_rating: 5.0,
    poster_reviews: 7,
    created_at: '2026-06-18T11:00:00Z',
  },
  {
    id: 'g-003',
    title: 'Dzīvokļa ģenerāltīrīšana pēc remonta',
    description: '2-istabu dzīvoklis (54 m²) jāuzkopj pēc kosmētiskā remonta — putekļi, logi, grīdas. Tīrīšanas līdzekļi nodrošināti.',
    category: 'cleaning',
    budget: 70,
    region: 'jurmala',
    city: 'Jūrmala, Majori',
    distance_km: 18.7,
    radius_km: 25,
    schedule: 'scheduled',
    scheduled_at: '2026-06-21T10:00:00Z',
    status: 'open',
    poster_name: 'Līga P.',
    poster_rating: 4.6,
    poster_reviews: 21,
    created_at: '2026-06-17T16:45:00Z',
  },
  {
    id: 'g-004',
    title: 'Jāuzstāda 3 sienas plaukti un karnīze',
    description: 'Ir IKEA plaukti un karnīze, vajag uzstādīt profesionāli. Visi instrumenti jāņem līdzi. Betona sienas.',
    category: 'handyman',
    budget: 35,
    region: 'riga',
    city: 'Rīga, Purvciems',
    distance_km: 7.8,
    radius_km: 15,
    schedule: 'asap',
    scheduled_at: null,
    status: 'accepted',
    poster_name: 'Mārtiņš Z.',
    poster_rating: 4.9,
    poster_reviews: 34,
    created_at: '2026-06-18T08:15:00Z',
  },
  {
    id: 'g-005',
    title: 'Dārza zāles pļaušana + krūmu apgriešana',
    description: 'Privātmājas dārzs ~600 m². Zāle un dzīvžogs. Trimmeris un zāles pļāvējs ir uz vietas.',
    category: 'gardening',
    budget: 50,
    region: 'cesis',
    city: 'Cēsis',
    distance_km: 1.2,
    radius_km: 20,
    schedule: 'scheduled',
    scheduled_at: '2026-06-20T12:00:00Z',
    status: 'open',
    poster_name: 'Pēteris L.',
    poster_rating: 4.7,
    poster_reviews: 9,
    created_at: '2026-06-18T07:00:00Z',
  },
  {
    id: 'g-006',
    title: 'Steidzama dokumentu piegāde Rīgas centrā',
    description: 'Jāaizved aploksne no Vecrīgas uz Teiku līdz plkst. 15:00. Kājām vai ar velo.',
    category: 'delivery',
    budget: 12,
    region: 'riga',
    city: 'Rīga, Vecrīga',
    distance_km: 3.3,
    radius_km: 6,
    schedule: 'asap',
    scheduled_at: null,
    status: 'completed',
    poster_name: 'Elīna V.',
    poster_rating: 4.5,
    poster_reviews: 5,
    created_at: '2026-06-16T13:20:00Z',
  },
];
